import { render, staticRenderFns } from "./UsernameChangeModal.vue?vue&type=template&id=ad12cbd2&scoped=true"
import script from "./UsernameChangeModal.vue?vue&type=script&lang=js"
export * from "./UsernameChangeModal.vue?vue&type=script&lang=js"
import style0 from "./UsernameChangeModal.vue?vue&type=style&index=0&id=ad12cbd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad12cbd2",
  null
  
)

export default component.exports